import { Grid } from "@mui/material";
import { formatCurrency } from "../../../../Utils/formatters";
import {
  OrganizerCardContainer,
  OrganizerCardStatus,
  OrganizerCardUpperBar,
} from "./styles";

interface OrganizerCardProps {
  name: string;
  idCustomer: string;
  value: number;
  totalValue: number;
  upperBarColor: string;
  statusColor: string;
  highlight?: string;
}

export function OrganizerCard(props: Partial<OrganizerCardProps>) {
  const value =
    props.value !== undefined
      ? formatCurrency(props.value)
      : "Sem valor definido";

  const normalize = (v: string) =>
    (v || "").toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const highlightText = (text?: string) => {
    const query = props.highlight || "";
    if (!text || !query) return text;
    const normText = normalize(text);
    const normQuery = normalize(query);
    if (!normQuery) return text;

    const parts: Array<string | JSX.Element> = [];
    let start = 0;
    let idx = normText.indexOf(normQuery, start);
    while (idx !== -1) {
      if (idx > start) parts.push(text.slice(start, idx));
      const end = idx + normQuery.length;
      parts.push(
        <mark key={`${idx}-${end}`} style={{ background: '#fff3bf', padding: 0 }}>
          {text.slice(idx, end)}
        </mark>
      );
      start = end;
      idx = normText.indexOf(normQuery, start);
    }
    if (start < text.length) parts.push(text.slice(start));
    return <>{parts}</>;
  };

  return (
    <OrganizerCardContainer>
      <OrganizerCardUpperBar bgColor={props.upperBarColor} />
      <div style={{ justifyContent: "space-between", display: "flex" }}>
        <h4>{highlightText(props.name)}</h4>
        <OrganizerCardStatus bgColor={props.statusColor} />
      </div>
        {props.idCustomer !== undefined ? (
          <h5>{highlightText(props.idCustomer)}</h5>
        ) : (
          <b></b>
        )}
        <br />
        {props.value !== undefined ? (
      <p style={{ margin: "1rem 0" }}>
          <span> Valor: {value} </span>
      </p>
        ) : (
          <b></b>
        )}
      <div style={{ fontSize: "1.2em", fontWeight: "bold", position: "absolute", bottom: "0" }}>
        {formatCurrency(props.totalValue)}
      </div>
    </OrganizerCardContainer>
  );
}
